import React from 'react';
import Utilities from '../utilities/MasterHeader'
import WhatDo from '../components/WhatDo'
import Philosophy from '../components/Philosophy'
import Splittel from '../components/Splittel'
import Footer from '../components/Footer'
import Graciass from '../components/graciass'

const Gracias = () => {
    return (
        <div>
            <Utilities />
            <Graciass />

            <Footer />
        </div>
    );
};

export default Gracias;
